var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect, useState } from 'react';
import FadeIn from '../../../../components/Animation/FadeIn';
import { useWizard } from '../../../../hooks/useWizard';
import Heading from '../../../../components/Typography/Heading';
import Paragraph from '../../../../components/Typography/Paragraph';
import { Plus } from 'react-feather';
import Drawer from '../../../../components/Drawer';
import ExperienceForm from '../../../../components/Fields/Experience/Form';
import { useForm } from 'react-hook-form';
import { useOutletContext } from 'react-router-dom';
import CardExperience from '../../../../components/Card/Experience';
import Button from '../../../../components/Button';
import ModalFull from '../../../../components/Modal/ModalFull';
import { Party } from '../../../../components/CustomIcon';
import classNames from 'classnames';
import FadeUp from '../../../../components/Animation/FadeUp';
import axiosInstance from '../../../../config/axios';
import { api } from '../../../../config/api';
import ModalBasic from '../../../../components/Modal/Basic';
import { deepEqual } from '../../../../utils/Objects';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
var ProfessionalExperience = function () {
    var _a, _b, _c;
    var values = useOutletContext().values;
    var _d = useWizard(), setValuesAndGoToNextStep = _d.setValuesAndGoToNextStep, skipAndGoToNextStep = _d.skipAndGoToNextStep;
    var _e = useState(), experience = _e[0], setExperience = _e[1];
    var _f = useState(), types = _f[0], setTypes = _f[1];
    var _g = useState(false), drawer = _g[0], setDrawer = _g[1];
    var _h = useState(false), modal = _h[0], setModal = _h[1];
    var _j = useState(), type = _j[0], setType = _j[1];
    var _k = useState(false), stepCompleted = _k[0], setStepCompleted = _k[1];
    var _l = useState(3000), modalDuration = _l[0], setModalDuration = _l[1];
    var maxExperiences = 3;
    var _m = useForm({
        defaultValues: values,
    }), setValue = _m.setValue, getValues = _m.getValues, watch = _m.watch;
    var handleDrawerClose = function () {
        setDrawer(false);
        setType(undefined);
        setExperience(undefined);
    };
    var handleDrawerBack = function () {
        type ? setType(undefined) : setDrawer(false);
    };
    var handleExperienceAdd = function (experienceObject) {
        var initialValues = getValues('experiences') || [];
        setValue('experiences', __spreadArray(__spreadArray([], initialValues, true), [experienceObject], false));
        handleDrawerClose();
    };
    var handleExperienceUpdate = function (experienceObject) {
        var initialValues = getValues('experiences') || [];
        var updatedValues = initialValues.map(function (previousExperience) {
            if (previousExperience === experience) {
                return experienceObject;
            }
            return previousExperience;
        });
        setValue('experiences', updatedValues);
        handleDrawerClose();
    };
    var handleExperienceDelete = function () { return __awaiter(void 0, void 0, void 0, function () {
        var initialValues, updatedValues;
        return __generator(this, function (_a) {
            initialValues = getValues('experiences') || [];
            updatedValues = initialValues.filter(function (el) { return !deepEqual(el, experience); });
            setValue('experiences', updatedValues);
            setModal(false);
            handleDrawerClose();
            return [2 /*return*/];
        });
    }); };
    var openDrawerWithData = function (experience) {
        setExperience(experience);
        setType(experience.type);
        setDrawer(true);
    };
    var onSubmit = function () {
        setStepCompleted(true);
        setTimeout(function () {
            setValuesAndGoToNextStep(getValues());
        }, modalDuration);
    };
    var skipStep = function () {
        setStepCompleted(true);
        setTimeout(function () {
            skipAndGoToNextStep();
        }, 3000);
    };
    useEffect(function () {
        axiosInstance
            .get(api.experiences.types)
            .then(function (response) {
            setTypes(response.data);
        })
            .catch(function (error) {
            console.log(error);
        });
    }, []);
    var _o = useState(watch('experiences')), experiences = _o[0], setExperiences = _o[1];
    var onDragEnd = function (result) {
        var newItems = Array.from(experiences);
        var removed = newItems.splice(result.source.index, 1)[0];
        newItems.splice(result.destination.index, 0, removed);
        setExperiences(newItems);
        setValue('experiences', newItems);
    };
    useEffect(function () {
        if (watch('experiences')) {
            setExperiences(watch('experiences'));
        }
    }, [watch('experiences')]);
    return (<>
      <FadeIn>
        <div className="flex flex-col py-10">
          <div>
            <Heading level={1} type="h4">
              Quelle(s) expérience(s) souhaitez-vous mettre en avant&nbsp;?
            </Heading>
            <Paragraph size="sm" className="pt-2 text-gray-700">
              Indiquez des expériences qui illustrent votre parcours : elles apparaîtront en haut de
              votre profil. Réorganisez-les facilement grâce à la fonctionnalité de glisser-déposer
              ! Vous pourrez renseigner toutes vos expériences un peu plus tard.
            </Paragraph>
          </div>
          <div className={classNames('mt-8 flex w-full cursor-pointer items-center rounded-lg', 'border border-dashed border-gray-400 bg-gray-100', 'p-4 transition-opacity md:mt-8 md:hover:opacity-60', ((_a = watch('experiences')) === null || _a === void 0 ? void 0 : _a.length) === maxExperiences && 'pointer-events-none opacity-50')} onClick={function () { return setDrawer(true); }}>
            <Plus size={24} className="mr-2"/>
            <span className="text-base font-medium">Ajouter une expérience</span>
          </div>
          <div className="mt-4 flex justify-end">
            <Paragraph className="text-gray-400">
              {"".concat((_c = (_b = watch('experiences')) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0, "/").concat(maxExperiences)}
            </Paragraph>
          </div>
          {experiences && (experiences === null || experiences === void 0 ? void 0 : experiences.length) > 0 && (<DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="droppable-2">
                {function (provided) { return (<div {...provided.droppableProps} ref={provided.innerRef}>
                    {experiences.map(function (experience, index) { return (<Draggable key={index} draggableId={"".concat(index)} index={index}>
                        {function (provided, snapshot) { return (<div ref={provided.innerRef} snapshot={snapshot} {...provided.draggableProps} {...provided.dragHandleProps} className="w-full">
                            <div className="py-3">
                              <CardExperience experience={experience} onClick={function () { return openDrawerWithData(experience); }} defaultHighlighted draggable={true} key={index}></CardExperience>
                            </div>
                          </div>); }}
                      </Draggable>); })}
                    {provided.placeholder}
                  </div>); }}
              </Droppable>
            </DragDropContext>)}
        </div>
        <div className="flex items-center justify-between">
          <Button onClick={skipStep} type="inline">
            Passer
          </Button>
          <Button onClick={onSubmit}>Continuer</Button>
        </div>

        <ModalFull open={stepCompleted} bgType={3} mainColClassName="max-md:mb-40" duration={modalDuration}>
          <FadeUp>
            <Party className="fill-white" size={86}/>
          </FadeUp>
          <FadeUp>
            <Heading level={1} type="h2" className="mt-6">
              Super !
            </Heading>
          </FadeUp>
          <FadeUp>
            <Paragraph size="lg" className="mt-2">
              Une dernière question avant de valider votre profil...
            </Paragraph>
          </FadeUp>
        </ModalFull>
      </FadeIn>

      <Drawer handleClose={handleDrawerClose} handleBack={handleDrawerBack} open={drawer}>
        {type ? (<ExperienceForm type={type} defaultValues={experience} onDelete={function () { return setModal(true); }} removable={!!experience} defaultHighlighted onSubmit={function (data) {
                return experience ? handleExperienceUpdate(data) : handleExperienceAdd(data);
            }}/>) : (<div className="px-drawer-lg pb-8">
            <Heading level={2} type="h6">
              Allons-y ! Quel type d’expérience voulez-vous ajouter&nbsp;?
            </Heading>
            {(types === null || types === void 0 ? void 0 : types.length) && (<div className="mt-4 grid grid-cols-2 gap-4 sm:mt-9">
                {types.map(function (type) { return (<div key={type.name} className="flex-center min-h-12 sm:min-h-20 cursor-pointer rounded-lg border border-gray-300 p-4 text-center transition-opacity hover:opacity-60" onClick={function () { return setType(type); }}>
                    {type.title}
                  </div>); })}
              </div>)}
          </div>)}
      </Drawer>
      <ModalBasic handleClose={function () { return setModal(false); }} open={modal} className="max-md:mx-4 max-md:h-auto">
        <div className="flex flex-col items-center gap-10 max-md:mb-6">
          <Heading level={2} type="h5" className="text-center">
            Souhaitez-vous vraiment supprimer cette expérience&nbsp;?
          </Heading>
          <div className="flex gap-6">
            <Button onClick={handleExperienceDelete} type="outlined" alert="danger">
              Supprimer
            </Button>
            <Button onClick={function () { return setModal(false); }} type="outlined">
              Annuler
            </Button>
          </div>
        </div>
      </ModalBasic>
    </>);
};
export default ProfessionalExperience;
